/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useAreServicesActive } from "../../../util/CommonServices";
import { ezsServiceIds } from "../../../config/UserServicesList";
import { useSelector, useDispatch } from "react-redux";
import * as FamilyServiceActions from "../../../store/familyService/actions";
import { ApplicationState } from "../../../store";
import { DialogComponent } from "../../common/DialogComponent";
import IDFCreditAuthentication from "../../Credit/Auth/IDFCreditAuthentication";
import * as CSIDActions from "../../../store/csid/actions";
import { ICSIDUserStatus } from "../../../store/csid/types";
import SeniorsFraudResolutionDialog from "../../Dialogs/SeniorsFraudResolutionDialog";
import EZSAddFamilyMemberDialog from "../../Dialogs/EZSAddFamilyMemberDialog";
import DeleteSeniorFamilyMemberDialog from "../../Dialogs/DeleteSeniorFamilyMemberDialog";
import * as LoginActions from "../../../store/loginService/actions";
import { useHistory } from "react-router-dom";
import ResendActivationMailDialog from "../../Dialogs/ResendActivationMailDialog";
import * as service from "../../../store/service";
import * as LoginTypes from "../../../store/loginService/types";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import moment from "moment-timezone";
import DeleteFamilyAccountDialog from "../../Dialogs/DeleteFamilyAccountDialog";
import RemoveFamilyMemberDialog from "../../Dialogs/RemoveFamilyMemberDialog";
import ThankYouDialogAddRemoveFamilyMember from "../../Dialogs/ThankYouDialogAddRemoveFamilyMember";
import { getCurrencyFormat } from "../../../util/common";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { isNullOrUndefined } from "util";
import { useTranslation } from "react-i18next";
const FamilyProtection: React.FunctionComponent<{ openAddFamilyProtectionDialog(): void }> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t: tLang } = useTranslation();
    const getFPSFamilySubscribers = () => dispatch(FamilyServiceActions.actionCreators.getFPSFamilySubscribers());
    const getSeniorFamilyMember = () => dispatch(FamilyServiceActions.actionCreators.getSeniorFamilyMember());
    const isFamilyProtectionServiceActive = useAreServicesActive([ezsServiceIds.familyProtectionService]);
    const isCCAMActive = useSelector((state: ApplicationState) => (state.loggedInUser && state.loggedInUser.userInfo?.hasCCAM ? true : false));
    const eZSChildSubscribers = useSelector((state: ApplicationState) =>
        state.familyServiceState && state.familyServiceState.eZSChildSubscribers ? state.familyServiceState.eZSChildSubscribers : []
    );
    const [isSeniorsFraudResolutionDialogVisible, setSeniorsFraudResolutionDialogIsVisible] = useState(false);
    const seniorMemberList = useSelector((state: ApplicationState) =>
        state.familyServiceState && state.familyServiceState.seniorMemberList ? state.familyServiceState.seniorMemberList : []
    );
    const isLoadingSFR = useSelector((state: ApplicationState) =>
        state.familyServiceState && state.familyServiceState.isLoadingSFR ? state.familyServiceState.isLoadingSFR : false
    );
    const [isRemoveSeniorAccountDialogVisible, setRemoveSeniorAccountDialogVisible] = useState(false);
    const [seniorMemberId, setSeniorMemberId] = useState(0);
    const [selectedSenior, setselectedSenior] = useState({});
    const [resendActivationEmailAccountDetails, setResendActivationEmailDetails] = useState({ firstName: "", lastName: "", email: "", subcustomerId: "" });
    const [isResendActivationMailDialogVisible, setResendActivationMailDialogVisible] = useState(false);

    const isSFRServiceActive = useAreServicesActive([
        ezsServiceIds.seniorsFraudRestoration,
        ezsServiceIds.seniorsFraudRestoration25K,
        ezsServiceIds.seniorsFraudRestoration1M,
    ]);
    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    const [isAddFamilyMemberDialogVisible, setAddFamilyMemberDialogIsVisible] = useState(false);
    const familyOffer = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState.familtOffer : null));
    const isLoadingFamilyOffer = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState.isLoadingFamilyOffer : false));
    const isLoadingFamilyMember = useSelector((state: ApplicationState) => (state.loggedInUser ? state.loggedInUser.isLoadingFamilyMember : false));
    const setChildSubCustomerIDToCompleteAccoutSetup = (subCustomerID: string) =>
        dispatch(LoginActions.actionCreators.setChildSubCustomerIDToCompleteAccountSetup(subCustomerID));
    const switchFamilyAccount = (activeAccount: LoginTypes.IUserFamilyAccountInfo, familyMembers: LoginTypes.IUserFamilyAccountInfo[]) =>
        dispatch(LoginActions.actionCreators.switchFamilyAccount(activeAccount, history, familyMembers));
    const setRedirectToDashboard = (forceUpdate: boolean) => dispatch(ConfigurationActions.actionCreators.setRedirectToDashboard(forceUpdate));
    const [removeAccountSubcustomerID, setRemoveAccountSubcustomerID] = useState("");
    const [isUserPaidMember, setIsUserPaidFamilyMember] = useState(false);
    const [isRemoveAccountDialogVisible, setRemoveAccountDialogVisible] = useState(false);
    const [isRemoveAccountConfirmationDialogVisible, setRemoveAccountConfirmationDialogVisible] = useState(false);

    const [selectedRelationshipType, setRelationshipType] = useState("Family Plan Adult");
    const [householdMembers, setHouseholdMembers] = useState(
        familyMembers.filter((x) => x.accountType === "Family Plan Adult" || x.accountType === "Family Plan Young Adult")
            ? familyMembers.filter((x) => x.accountType === "Family Plan Adult" || x.accountType === "Family Plan Young Adult")
            : []
    );
    const [childFamilyMembers, setChildFamilyMembers] = useState(
        familyMembers.filter((x) => x.accountType === "Family Plan Child") ? familyMembers.filter((x) => x.accountType === "Family Plan Child") : []
    );
    const packageInformationData = useSelector((state: ApplicationState) =>
        state?.protectionPlanState?.protectionPlanData?.packageList ? state?.protectionPlanState?.protectionPlanData?.packageList : []
    );

    const getUserCSIDStatus = () => dispatch(CSIDActions.actionCreators.getUserCSIDStatus());
    const refreshContext = () => dispatch(CSIDActions.actionCreators.componentNeedsRefresh());

    const csidUserStatus = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus : null
    );

    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const userCountry = useSelector((state: ApplicationState) =>
        state.myAccountServiceState?._unifiedAccountInfo?.country
    );
    const countryRequiresAuthentication = useSelector((state: ApplicationState) => {
        return ['US', 'CA'].includes(userCountry || '');
    });

    const isAuthenticated = !countryRequiresAuthentication || csidUserStatus?.["auth-status"]?.toLocaleLowerCase() === "authenticated";

    const shouldShowError = !isAuthenticated && (userCountry !== "CA");
    const shouldShowCTA = userCountry === "CA" && !isAuthenticated;
    const canAddChild = isAuthenticated || userCountry !== "CA";

    const activePackage = packageInformationData ? packageInformationData.find((x) => x.IsActive === true) : null;
    const [isThankYouDialogVisible, setThankYouDialogVisible] = useState(false);
    const [thankYouPopDetails, setThankYouPopDetails] = useState({
        planCost: 0.0,
        totalCost: 0.0,
        tax: 0.0,
        familyProtectionCharge: 0.0,
        newCharge: 0.0,
        message: "",
        adultCount: 0,
        refund: 0.0,
    });

    useEffect(() => {
        getFPSFamilySubscribers();
        if (isSFRServiceActive) {
            getSeniorFamilyMember();
        }
    }, []);

    useEffect(() => {
        const households = familyMembers.filter((x) => x.accountType === "Family Plan Adult" || x.accountType === "Family Plan Young Adult")
            ? familyMembers.filter((x) => x.accountType === "Family Plan Adult" || x.accountType === "Family Plan Young Adult")
            : [];
        setHouseholdMembers(households);
        const childfamilymembers = familyMembers.filter((x) => x.accountType === "Family Plan Child")
            ? familyMembers.filter((x) => x.accountType === "Family Plan Child")
            : [];
        setChildFamilyMembers(childfamilymembers);
    }, [familyMembers.length]);

    const openRemoveSeniorMemberDialog = (id: number): any => {
        if (id && id !== 0) {
            setSeniorMemberId(id);
            setRemoveSeniorAccountDialogVisible(true);
        }
    };

    const closeRemoveSeniorMemberDialog = (): any => {
        setRemoveSeniorAccountDialogVisible(false);
    };

    const openSeniorsFraudResolutionDialog = (seniorMember: any): any => {
        setselectedSenior(seniorMember);
        setSeniorsFraudResolutionDialogIsVisible(true);
    };

    const closeSeniorsFraudResolutionDialog = (): any => {
        setSeniorsFraudResolutionDialogIsVisible(false);
    };

    const openAddFemilyMemberDialog = (relatioshipType: string): any => {
        setRelationshipType(relatioshipType);
        setAddFamilyMemberDialogIsVisible(true);
    };

    const closeAddFemilyMemberDialog = (isSuccess?: boolean): any => {
        setAddFamilyMemberDialogIsVisible(false);
        if (isSuccess) {
            openThankYouDialog();
        }
    };

    const openResendActivationMailDialog = (): any => {
        setResendActivationMailDialogVisible(true);
    };

    const closeResendActivationMailDialog = (): any => {
        setResendActivationMailDialogVisible(false);
    };
    const getRelationTypeText = (key?: string): any => {
        if (key) {
            switch (key) {
                case "grandparent":
                    return "Grandparent";
                case "grandparent-in-law":
                    return "Grandparent-In-Law";
                case "parent":
                    return "Parent";
                case "parent-in-law":
                    return "Parent-In-Law";

                default:
                    return "";
            }
        } else {
            return "";
        }
    };

    const requestAccountSwitch = (subcustomerID: string, accountToSwitch: any) => {
        const requestBody = { SubcustomerId: subcustomerID };

        service.switchFamilyAccount(requestBody).then((data) => {
            if (!data["hasError"] && data["familyMembers"]) {
                if (accountToSwitch) {
                    switchFamilyAccount(accountToSwitch, data["familyMembers"]);

                    const path = window.location.pathname;
                    if (path.toLowerCase().endsWith("dashboard")) {
                        setRedirectToDashboard(true);
                        history.push("/switch-account");
                    }
                }
            }
        });
    };

    const switchUserAccount = (subcustomerID?: string) => {
        if (subcustomerID) {
            const accountToSwitch = familyMembers.find((x) => x.subcustomerId === subcustomerID);
            if (isCCAMActive ? true : subcustomerID) {
                requestAccountSwitch(subcustomerID, accountToSwitch);
            } else {
                if (accountToSwitch && accountToSwitch.setUpCompleteDate != null) {
                    requestAccountSwitch(subcustomerID, accountToSwitch);
                } else {
                    if (accountToSwitch) {
                        setChildSubCustomerIDToCompleteAccoutSetup(subcustomerID);
                        history.push("/complete-family-setup");
                    }
                }
            }
        }
    };

    const openRemoveDialog = (): any => {
        setRemoveAccountDialogVisible(true);
    };

    const closeRemoveDialog = (): any => {
        setRemoveAccountDialogVisible(false);
    };

    const closeRemoveMemeberConfirmationDialog = (isSuccess: boolean): any => {
        setRemoveAccountConfirmationDialogVisible(false);
        setAddFamilyMemberDialogIsVisible(false);
        if (isSuccess) {
            openThankYouDialog();
        }
    };

    const openThankYouDialog = (): any => {
        setThankYouDialogVisible(true);
    };

    const closeThankYouDialog = (): any => {
        setThankYouDialogVisible(false);
    };

    const removeAccount = (member: any) => {
        const subCustomerId = member["subcustomerId"];
        if (!!subCustomerId) {
            setRemoveAccountSubcustomerID(subCustomerId);
            setIsUserPaidFamilyMember(!!member["price"]);
            openRemoveDialog();
        }
    };

    const [showAuthenticationDialog, setShowAuthenticationDialog] = useState(false);

    const closeTuIdfAuthDialog = (): any => {
        getUserCSIDStatus();
        setShowAuthenticationDialog(false);
        refreshContext();
    };

    const closeDisclosureDialogCallBack = (callbackObj: any) => {
        setShowAuthenticationDialog(false);
        refreshContext();
    };


    useEffect(() => {
        if (history.location.hash.includes("#family-protection")) {
            document.getElementById("family-protection") && document.getElementById("family-protection")!.scrollIntoView({ block: "center", behavior: "smooth" });
        }
    }, [isLoadingSFR, familyOffer]);

    return (
        <React.Fragment>
            <div
                className={isLoadingSFR || isLoadingFamilyOffer || isLoadingFamilyMember ? "box offset-padding loading" : "box offset-padding"}
                id="family-protection"
            >
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon" aria-hidden="true">
                            <RenderIcons iconName="users" />
                        </div>
                        <div className="box-title-text has-actions">
                            <h2 className="box-title">{tLang("manageAccount.myAccount.familyProtection.title")}</h2>
                        </div>
                    </div>
                </div>
                <div className="box-content">

                    {isFamilyProtectionServiceActive && (
                        <div role="grid" className="data-grid " id="user-grid" aria-hidden="false">
                            {eZSChildSubscribers.map((member, index) => {
                                return (
                                    <div key={index} role="row" className="data-row row between-xs between-sm">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label">
                                                <em className="las la-user-circle" style={{ fontSize: "1.25rem", lineHeight: "1.5rem", verticalAlign: "top" }}></em>
                                                {` ${member.firstName} ${member.lastName}`}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                            <div className="margin-top-l"></div>

                            {eZSChildSubscribers.length <= 0 && (
                                <div role="row">
                                    <div role="gridcell">
                                        <p>
                                            <a onClick={props.openAddFamilyProtectionDialog} href="javascript:void(0);" className="default_link">
                                                <em className="las la-plus"></em> {tLang("manageAccount.myAccount.familyProtection.addFamilyMemberText")}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* child member */}
                    {familyOffer && familyOffer.familyChildOffer?.hasChildOffer && shouldShowError && (

                        <div>
                            <div className="dialog-header">
                                <h2>
                                    <span className="dialog-icon status-default">
                                        <em className="las la-exclamation-triangle"></em>
                                    </span>
                                    &nbsp;{tLang("dashboard.addFamilyMemberDialog.childwatch.identityVerificationMessageTitle")}
                                </h2>
                            </div>
                            <div className="dialog-body">
                                <p>{tLang("dashboard.addFamilyMemberDialog.childwatch.identityVerificationMessage1")}</p>
                                <p>
                                    {tLang("dashboard.addFamilyMemberDialog.childwatch.identityVerificationMessage2")}{" "}
                                    <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber} </a>{" "}
                                    {tLang("dashboard.addFamilyMemberDialog.childwatch.identityVerificationMessage3")}
                                </p>
                            </div>

                        </div>
                    )}

                    {familyOffer && familyOffer.familyChildOffer?.hasChildOffer && (
                        <>
                            <div role="grid" className="data-grid " id="child-family-member-grid" aria-hidden="false">
                                <div role="row" className="box-title-text has-actions margin-bottom-xs">
                                    <div role="gridcell">
                                        <h4 className="box-title">{tLang("manageAccount.myAccount.familyProtection.childMonitoringText")}</h4>
                                    </div>
                                </div>

                                <br />

                                {familyOffer && familyOffer.familyChildOffer?.hasChildOffer && shouldShowCTA && (
                                    <div className="data-grid" role="grid" style={{ backgroundColor: "#F2F6F9", width: "100%", padding: "10px" }}>
                                        <div className="box-header col-xs-12 col-sm-12 ">
                                            <div className="content-sub-title text-align-center">
                                                <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                                    <em className="las la-exclamation-circle "></em>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="box-content text-align-center margin-bottom-s">
                                            <p>To add child monitoring,</p>
                                            <p>Please authenticate your identity</p>
                                            <button type="submit" className="btn-default btn-primary" onClick={() => setShowAuthenticationDialog(true)}>
                                                <span className="btn-text">Authenticate</span>
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {childFamilyMembers.map((member, index) => {
                                    return (
                                        <div role="row" key={`child-${index}`} className="data-row row between-xs between-sm item-divider">
                                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter padding-bottom-s">
                                                <div>
                                                    <em className="las la-user-circle">&nbsp;</em>
                                                    {` ${member.firstName} ${member.lastName}`}
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter padding-bottom-s">
                                                <a
                                                    href="#"
                                                    className="default_link"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        switchUserAccount(member.subcustomerId);
                                                    }}
                                                >
                                                    {tLang("manageAccount.myAccount.familyProtection.switchAccountText")}
                                                </a>
                                            </div>
                                            {!member.cancelDate && (
                                                <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter padding-bottom-s text-align-right">
                                                    <a onClick={() => removeAccount(member)} href="javascript:void(0);" className="default_link">
                                                        {tLang("manageAccount.myAccount.familyProtection.removeText") +" "+ member.firstName}
                                                    </a>
                                                </div>
                                            )}
                                            {member.cancelDate && (
                                                <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter padding-bottom-s text-align-right">
                                                    <span className="form-error">
                                                        <p>Cancelling on {moment(member.cancelDate).format("MMM D, YYYY")}</p>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                                {childFamilyMembers && canAddChild && (
                                    <div role="row">
                                        <div role="gridcell">
                                            <p>
                                                {((familyOffer.familyChildOffer?.childMaxLimit === childFamilyMembers?.length) || (childFamilyMembers?.length === 10)) ?
                                                    <a
                                                    href="javascript:void(0);"
                                                    className="default_link disable_link"
                                                    tabIndex={-1}
                                                    >
                                                        <em className="las la-plus"></em> {tLang("manageAccount.myAccount.familyProtection.addChildMonitoringText")}
                                                    </a> :
                                                    <a
                                                        onClick={() => openAddFemilyMemberDialog("Family Plan Child")}
                                                        href="javascript:void(0);"
                                                        className="default_link"
                                                    >
                                                        <em className="las la-plus"></em> {tLang("manageAccount.myAccount.familyProtection.addChildMonitoringText")}
                                                    </a>
                                                }
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="margin-top-l"></div>
                        </>
                    )}

                    {/* adult member */}
                    {familyOffer && familyOffer.familyAdultOffer?.hasAdultOffer && (
                        <>
                            <div role="grid" className="data-grid margin-top-xl" id="household-family-member-grid" aria-hidden="false">
                                <div role="row" className="box-title-text has-actions margin-bottom-xs">
                                    <div role="gridcell">
                                        <h4 className="box-title">{tLang("manageAccount.myAccount.familyProtection.householdAdultMemberText")}</h4>
                                    </div>
                                </div>

                                <br />

                                {householdMembers.map((member, index) => {
                                    return (
                                        <div role="row" key={`household-${index}`} className="data-row row between-xs between-sm item-divider">
                                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter padding-bottom-s">
                                                <div>
                                                    <em className="las la-lock">&nbsp;</em>
                                                    {member.firstName || member.lastName ? (
                                                        <>
                                                            {member.firstName} {member.lastName}
                                                        </>
                                                    ) : (
                                                        <>Not yet activated</>
                                                    )}
                                                    &nbsp;
                                                    {familyOffer.familyAdultOffer?.isUserPaid && !isNullOrUndefined(member.price) && (
                                                        <span>{` - ${getCurrencyFormat(i18nService.get("Country"))}${Number(member.price).toFixed(2)}/${
                                                            activePackage?.SubcriptionType === "Yearly" ? "yr" : "mo"
                                                            }`}</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter padding-bottom-s">
                                                {!member.registrationStatus && (
                                                    <a
                                                        href="javascript:void(0);"
                                                        className="default_link"
                                                        onClick={() => {
                                                            setResendActivationEmailDetails({
                                                                ...resendActivationEmailAccountDetails,
                                                                firstName: member.firstName ? member.firstName : "",
                                                                lastName: member.lastName ? member.lastName : "",
                                                                email: member.email ? member.email : "",
                                                                subcustomerId: member.subcustomerId ? member.subcustomerId : "",
                                                            });
                                                            openResendActivationMailDialog();
                                                        }}
                                                    >
                                                        {tLang("manageAccount.myAccount.familyProtection.resendEmail")}
                                                    </a>
                                                )}
                                            </div>

                                            {!member.cancelDate && (
                                                <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter padding-bottom-s text-align-right">
                                                    <a onClick={() => removeAccount(member)} href="javascript:void(0);" className="default_link">
                                                        {tLang("manageAccount.myAccount.familyProtection.removeText")} {member.firstName || "household member"}
                                                    </a>
                                                </div>
                                            )}
                                            {member.cancelDate && (
                                                <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter padding-bottom-s text-align-right">
                                                    <span className="form-error">
                                                        <p>Cancelling on {moment(member.cancelDate).format("MMM D, YYYY")}</p>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}

                                {/* familyOffer?.familyAdultOffer?.adultMaxLimit === 0 means unlimited*/}
                                {householdMembers &&
                                    familyOffer?.familyAdultOffer?.adultMaxLimit &&
                                    (familyOffer?.familyAdultOffer?.adultMaxLimit === 0 ||
                                        householdMembers.length < familyOffer?.familyAdultOffer?.adultMaxLimit) && (
                                        <div role="row">
                                            <div role="gridcell">
                                                <p>
                                                    {" "}
                                                    <a
                                                        onClick={() => openAddFemilyMemberDialog("Family Plan Adult")}
                                                        href="javascript:void(0);"
                                                        className="default_link"
                                                    >
                                                        <em className="las la-plus"></em> {tLang("manageAccount.myAccount.familyProtection.addHouseholdAdultMemberText")}
                                                        {familyOffer.familyAdultOffer?.isUserPaid && (
                                                            <span>
                                                                &nbsp;for&nbsp;{getCurrencyFormat(i18nService.get("Country"))}
                                                                {activePackage?.SubcriptionType === "Yearly"
                                                                    ? familyOffer.familyAdultOffer?.payAsYouGoAnnualPrice?.toFixed(2)
                                                                    : familyOffer.familyAdultOffer?.payAsYouGoMonthlyPrice?.toFixed(2)}
                                                                /{activePackage?.SubcriptionType === "Yearly" ? "yr" : "mo"}
                                                            </span>
                                                        )}
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    )}
                            </div>

                            <div className="margin-top-l"></div>
                        </>
                    )}

                    {isSFRServiceActive && (
                        <div role="grid" className="data-grid margin-top-xl" id="senior-fraud-grid" aria-hidden="false">
                            <div role="row" className="box-title-text has-actions margin-bottom-xs">
                                <div role="gridcell">
                                    <h4 className="box-title">Seniors Fraud Resolution</h4>
                                </div>
                            </div>

                            <br />

                            {seniorMemberList.map((senior, index) => {
                                return (
                                    <>
                                        <div key={`sfr-${index}`} role="row" className="data-row row between-xs between-sm item-divider">
                                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter padding-bottom-s">
                                                <div>
                                                    <em className="las la-lock"></em>
                                                    {` ${senior.firstName} ${senior.lastName}`}
                                                </div>
                                                <div className="margin-left-s margin-top-xs">
                                                    <small>{getRelationTypeText(senior.relationshipType)}</small>
                                                </div>
                                            </div>
                                            <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter padding-bottom-s">
                                                <a href="javascript:void(0);" className="default_link" onClick={() => openSeniorsFraudResolutionDialog(senior)}>
                                                    Edit
                                                </a>
                                            </div>
                                            <div role="gridcell" className="col-xs-6 col-sm-4 col-no-gutter padding-bottom-s text-align-right">
                                                <a
                                                    href="javascript:void(0);"
                                                    className="default_link"
                                                    onClick={() => openRemoveSeniorMemberDialog(senior.id ? senior.id : 0)}
                                                >
                                                    Remove{` ${senior.firstName}`}
                                                </a>
                                            </div>
                                        </div>
                                    </>
                                );
                            })}

                            {seniorMemberList.length < 8 && (
                                <div role="row">
                                    <div role="gridcell">
                                        <p>
                                            <a onClick={() => openSeniorsFraudResolutionDialog(null)} href="javascript:void(0);" className="default_link">
                                                <em className="las la-plus"></em> Add Senior to Protect
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {showAuthenticationDialog && (
                <DialogComponent dialogId="dialog-tu-idf-auth" title="TU-IDF L3 Auth" closeDialog={closeDisclosureDialogCallBack} hideCloseButton={false} noEsc={false}>
                    <IDFCreditAuthentication
                        initCSIDUserStatus={csidUserStatus as ICSIDUserStatus}
                        creditAuthCallback={closeTuIdfAuthDialog}
                        displayFlowAsDialog={false}
                    />
                </DialogComponent>
            )}


            {isSeniorsFraudResolutionDialogVisible && (
                <DialogComponent
                    dialogId="dialog-add-seniors-fraud-resolution"
                    title="Add Seniors Fraud Resolution"
                    closeDialog={closeSeniorsFraudResolutionDialog}
                >
                    <SeniorsFraudResolutionDialog seniorMember={selectedSenior} closeDialog={closeSeniorsFraudResolutionDialog} />
                </DialogComponent>
            )}
            {isRemoveSeniorAccountDialogVisible && (
                <DialogComponent
                    dialogId="dialog-remove-senior-member-account-dialog-idf-family-service"
                    title="Remove Senior Member"
                    closeDialog={closeRemoveSeniorMemberDialog}
                >
                    <DeleteSeniorFamilyMemberDialog seniorMemberId={seniorMemberId} closeDialog={closeRemoveSeniorMemberDialog} />
                </DialogComponent>
            )}
            {isAddFamilyMemberDialogVisible && (
                <DialogComponent dialogId="dialog-ezs-add-family-member" title="Add Family Member" closeDialog={closeAddFemilyMemberDialog}>
                    <EZSAddFamilyMemberDialog
                        relationshipType={selectedRelationshipType}
                        history={history}
                        closeDialog={closeAddFemilyMemberDialog}
                        setThankYouPopUpDetails={setThankYouPopDetails}
                        dialogId={"dialog-ezs-add-family-member"}
                        childFamilyMembers={childFamilyMembers}
                    />
                </DialogComponent>
            )}
            {isResendActivationMailDialogVisible && (
                <DialogComponent
                    dialogId="dialog-add-family-member-account-dialog-resend-activation-email"
                    title="Resend activation email"
                    closeDialog={closeResendActivationMailDialog}
                >
                    <ResendActivationMailDialog
                        firstName={resendActivationEmailAccountDetails.firstName}
                        lastName={resendActivationEmailAccountDetails.lastName}
                        email={resendActivationEmailAccountDetails.email}
                        subcustomerId={resendActivationEmailAccountDetails.subcustomerId}
                        closeDialog={closeResendActivationMailDialog}
                    />
                </DialogComponent>
            )}
            {isRemoveAccountDialogVisible && (
                <DialogComponent
                    dialogId="dialog-remove-family-member-account-dialog-ezs-family-service"
                    title="Remove Family Member"
                    closeDialog={closeRemoveDialog}
                >
                    <DeleteFamilyAccountDialog
                        subCustomerId={removeAccountSubcustomerID}
                        isUserPaid={isUserPaidMember}
                        closeDialog={closeRemoveDialog}
                        showConfirmationPaymentInfo={setRemoveAccountConfirmationDialogVisible}
                    />
                </DialogComponent>
            )}
            {isRemoveAccountConfirmationDialogVisible && (
                <DialogComponent
                    dialogId="dialog-remove-family-member-account-dialog-ezs-family-service-confirmation"
                    title="Remove Family Member Confirmation"
                    closeDialog={closeRemoveMemeberConfirmationDialog}
                >
                    <RemoveFamilyMemberDialog
                        closeDialog={closeRemoveMemeberConfirmationDialog}
                        subCustomerId={removeAccountSubcustomerID}
                        setThankYouPopupDetails={setThankYouPopDetails}
                    />
                </DialogComponent>
            )}
            {isThankYouDialogVisible && (
                <DialogComponent
                    dialogId="dialog-remove-family-member-account-dialog-ezs-family-service"
                    title="Remove Family Member"
                    closeDialog={closeThankYouDialog}
                >
                    <ThankYouDialogAddRemoveFamilyMember props={thankYouPopDetails} closeDialog={closeThankYouDialog} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default FamilyProtection;
